import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
// import { AppThunk } from '../../reduxstore';

// export const setErrorAction =
// 	(data: ErrorState): AppThunk =>
// 	async (dispatch: any) => {
// 		try {
// 			const errMessage = data?.error ? data.error : null;
// 			const res: ErrorState = {
// 				hasError: true,
// 				error: errMessage,
// 				status: data?.status ? data.status : null
// 			};
// 			if (errMessage) {
// 				dispatch(setErrors(res));
// 			} else {
// 				dispatch(clearErrors());
// 			}
// 		} catch (error) {
// 			//
// 		}
// 	};

const slice = createSlice({
	name: 'errorSlice',
	initialState: {
		hasError: null,
		error: null,
		status: null
	} as ErrorState,
	reducers: {
		setErrors: (
			state,
			{ payload: { error, status } }: PayloadAction<ErrorState>
		) => {
			state.hasError = true;
			state.error = error;
			state.status = status;
		},
		clearErrors: state => {
			state.hasError = null;
			state.error = null;
			state.status = null;
		}
	}
});

export const { setErrors, clearErrors } = slice.actions;

// export const ErrorReducer = slice.reducer;
export default slice.reducer;
